'use strict';

angular.module('lingApp')
  .directive('ripKeyEnter', function () {
    return function(scope, element, attrs) {
      element.bind('keydown keypress', function(event) {
        if (13 === event.which) {
          scope.$apply(function() {
            scope.$eval(attrs.ripKeyEnter);
          });

          event.preventDefault();
        }
      });
    };
  });
